// tslint:disable
export enum TCSMedBenefitCommunicationType {
    /**
     * @description Mail
     */
    Mail = 0,
    /**
     * @description Fax
     */
    Fax = 1,
    /**
     * @description Voice Mail
     */
    Voicemail = 2,
    /**
     * @description Phone
     */
    Phone = 3,
    /**
     * @description Email
     */
    Email = 4,
    /**
     * @description Feed
     */
    Feed = 5,
    /**
     * @description Void
     */
    Void = 6,
    /**
     * @description Message Center
     */
    Message = 7,
    /**
     * @description Patient / Legal Guardian (if under 18)
     */
    Guardian = 8,
}
(TCSMedBenefitCommunicationType as any)['MAIL'] = 0;
(TCSMedBenefitCommunicationType as any)['FAX'] = 1;
(TCSMedBenefitCommunicationType as any)['VOICEMAIL'] = 2;
(TCSMedBenefitCommunicationType as any)['PHONE'] = 3;
(TCSMedBenefitCommunicationType as any)['EMAIL'] = 4;
(TCSMedBenefitCommunicationType as any)['FEED'] = 5;
(TCSMedBenefitCommunicationType as any)['VOID'] = 6;
(TCSMedBenefitCommunicationType as any)['MESSAGE'] = 7;
(TCSMedBenefitCommunicationType as any)['GUARDIAN'] = 8;
